var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 18C4.75 17.5858 4.41421 17.25 4 17.25C3.58579 17.25 3.25 17.5858 3.25 18V21C3.25 21.9665 4.0335 22.75 5 22.75H19C19.9665 22.75 20.75 21.9665 20.75 21V18C20.75 17.5858 20.4142 17.25 20 17.25C19.5858 17.25 19.25 17.5858 19.25 18V21C19.25 21.1381 19.1381 21.25 19 21.25H5C4.86193 21.25 4.75 21.1381 4.75 21V18Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.25C12.1989 1.25 12.3897 1.32902 12.5303 1.46967L18.0606 7C18.2751 7.2145 18.3393 7.53709 18.2232 7.81734C18.1071 8.0976 17.8337 8.28033 17.5303 8.28033H12.75V17C12.75 17.4142 12.4142 17.75 12 17.75C11.5858 17.75 11.25 17.4142 11.25 17V8.28033H6.46966C6.16631 8.28033 5.89283 8.0976 5.77675 7.81734C5.66066 7.53709 5.72483 7.2145 5.93933 7L11.4697 1.46967C11.6103 1.32902 11.8011 1.25 12 1.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadAlt);
export default __webpack_public_path__ + "static/media/upload-alt.af2fd382d508bd7a418afa26c4194850.svg";
export { ForwardRef as ReactComponent };